<template>
  <div class="main_">
    <div class="fixed" v-if="!isWx">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />

            <!-- <div class="search_con m_flex_box flex_vc">
              <van-icon name="search" />
              <input
                class="middle"
                type="text"
                v-model="itemName"
                placeholder="搜索"
                @keyup.enter="submit"
              />
            </div> -->
          </div>
          <div style="text-align: center; font-size: 0.35rem">我的报名记录</div>
          <p
            class="header_address m_flex_box flex_vc"
            @click="showPicker = true"
          >
            <span>{{ auditName }}</span>
          </p>
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              value-key="name"
              :columns="jdrray"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup>
        </div>
      </div>
    </div>
    <div class="fixed_pad" v-if="!isWx"></div>
    <div class="list_main">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="" />
        </div>
        <div class="list_con pre_list">
          <div
            class="inner m_flex_box"
            v-for="(item, index) in list"
            :key="index"
          >
            <!-- <div class="inner_l">
              <img
                class="banner"
                v-lazy="imgPath + 'sImgMin/' + item.imgid + '.jpg'"
              />
            </div> -->
            <div class="new_r">
              <div class="m_flex_box flex_vc flex_jz tit">
                <h4 class="line_comp1">{{ item.preItemName }}</h4>
                <span class="span_one" v-if="item.auditFlow == '1'">
                  通过
                </span>
                <span class="span_two" v-if="item.auditFlow == '2'">
                  驳回
                </span>
                <span class="span_three" v-if="item.auditFlow == '0'">
                  待审核
                </span>
              </div>
              <div>
                <!-- <p class="line_comp1 col_gray">
                  项目名称:{{ item.preItemName }}
                </p> -->
                <p class="line_comp1 col_gray">姓名:{{ item.userName }}</p>
                <p class="line_comp1 col_gray">证件号:{{ item.idCardNo }}</p>
                <p class="line_comp1 col_gray">
                  人员类型:{{ item.talentType }}
                </p>
                <p class="line_comp1 col_gray">
                  报名时间:{{ item.createDate }}
                </p>
                <p class="line_comp1 col_gray">审核反馈：</p>
                <p>{{ item.refuseInfo ? item.refuseInfo : "-" }}</p>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- <div class="confirmBtn">
      <p @click="confirm">我要报名</p>
    </div> -->
    <van-overlay :show="show" @click="show = false" :lock-scroll="false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <h3>商品住房预约选房平台报名须知</h3>
          <p>
            1、用户在APP端报名时填写的资料必须真实有效，用户需对自己提供的资料真实性负责。
          </p>
          <p>
            2、用户提供的所有报名信息，需要开发商进行审核，审核通过之后，会进入预约选房平台，并获得相应的报名序号。如果审核失败，需重新报名。
          </p>
          <p>
            3、新项目开启现场报名的周期为至少3个工作日，APP端的报名通道会在项目现场报名结束的前一天关闭。
            <span>
              如果购房者未能及时通过APP进行报名，或者通过APP报名后审核未通过，购房者可以在随后的一天前往开发商处现场进行报名。
            </span>
          </p>
          <p>
            4、购房者的报名申请会在项目的报名阶段审核完毕，请在APP上关注您的审核状态。如出现异常情况，请与您的开发商联系。
          </p>
          <p>
            5、所有商品住房的预约选房进度公示请在
            “首页->公示公告->商品住房预约选房平台”
            之中查看。也可在首页和新房页面的“报名选房”入口查看。
          </p>
          <div class="describe">
            <van-checkbox v-model="checked" shape="square"
              >我已仔细阅读以上说明</van-checkbox
            >
          </div>
          <div class="btn">
            <p class="sure" @click="show = false">取消</p>
            <p :class="!checked ? 'mayNot' : 'sure_two'" @click="signUp">
              确定报名
            </p>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- <div class="overlay" v-show="show" @click="show = false">
      <div class="block" @click.stop>
        <h3>商品住房预约选房平台报名须知</h3>
        <p>
          1、用户在APP端报名时填写的资料必须真实有效，用户需对自己提供的资料真实性负责。
        </p>
        <p>
          2、用户提供的所有报名信息，需要开发商进行审核，审核通过之后，会进入预约选房平台，并获得相应的报名序号。如果审核失败，需重新报名。
        </p>
        <p>
          3、新项目开启现场报名的周期为至少3个工作日，APP端的报名通道会在项目现场报名结束的前一天关闭。
          <span>
            如果购房者未能及时通过APP进行报名，或者通过APP报名后审核未通过，购房者可以在随后的一天前往开发商处现场进行报名。
          </span>
        </p>
        <p>
          4、购房者的报名申请会在项目的报名阶段审核完毕，请在APP上关注您的审核状态。如出现异常情况，请与您的开发商联系。
        </p>
        <p>
          5、所有商品住房的预约选房进度公示请在
          “首页->公示公告->商品住房预约选房平台”
          之中查看。也可在首页和新房页面的“报名选房”入口查看。
        </p>
        <div class="describe">
          <van-checkbox v-model="checked" shape="square"
            >我已仔细阅读以上说明</van-checkbox
          >
        </div>
        <div class="btn">
          <p class="sure" @click="show = false">取消</p>
          <p :class="!checked ? 'mayNot' : 'sure_two'" @click="signUp">
            确定报名
          </p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";

export default {
  name: "AnnouncePre",
  data() {
    return {
      checked: false,
      show: false,
      isApp: sessionStorage.getItem("isApp") || false,
      isWx: sessionStorage.getItem("isWx") || false,
      auditName: "全部",
      auditFlow: "",
      showPicker: false,
      itemName: "",
      selectedStep: 0,
      tab: {
        showArea: false,
        showYear: false,
        showCerNo: false,
      },
      priceType: 1,
      formData: {
        xzqh: this.main.getHostArea(),
        year: "",
        cerNo: "",
        mc: "",
      },
      showPad: false,
      showCover: false,
      loading: false,
      finished: false,
      status: "",
      jdrray: [
        {
          name: "全部",
          key: "",
        },
        {
          name: "通过",
          key: "1",
        },
        {
          name: "驳回",
          key: "2",
        },
        {
          name: "待审核",
          key: "0",
        },
      ],
      yearArray: [],
      cerNoArray: [],
      xzqhDefault: this.main.getHostArea(),
      items: "",
      pageIndex: 1,
      list: [],
      timer: null,
      isLoading: false,
      token: "",
    };
  },
  components: {
    topHeader,
  },
  created() {
    this.assignmentTooken();
  },
  mounted() {},
  methods: {
    assignmentTooken() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        var ua = navigator.userAgent;
        var uaList = ua.split(" ");
        var token = "";
        for (var i = 0; i < uaList.length; i++) {
          if (uaList[i].indexOf("token") > -1) {
            token = uaList[i].split("=")[1];
            break
          }
        }
        this.token = token;
      } else {
        if ((this.isWx && this.isWx != "false") || this.isWx == "true") {
          if (window.sessionStorage.getItem("wxAppToken")) {
            this.token = sessionStorage.getItem("wxAppToken");
          }
        } else {
          if (JSON.parse(window.localStorage.getItem("tokenObj"))) {
            this.token = JSON.parse(localStorage.getItem("tokenObj")).appToken;
          }
        }
      }
    },
    goback() {
      this.$router.go(-1);
    },
    submit() {
      this.loading = true;
      this.finished = true;
      this.pageIndex = 1;
      this.list = [];
      this.onLoad(1);
    },
    onConfirm(value) {
      this.auditFlow = value.key;
      this.auditName = value.name;
      this.showPicker = false;
      this.pageIndex = 1;
      this.list = [];
      this.onLoad(1);
    },

    confirm() {
      this.show = true;
    },
    signUp() {
      if (this.checked) {
        this.$router.push({
          path: "/ItemList",
        });
      }
    },

    // 初始化
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        this.$http
          .post(
            "/house/api/ysbm/grybmList.do",
            qs.stringify({
              appToken: this.token,
              pageSize: 10,
              pageIndex: this.pageIndex,
              auditFlow: this.auditFlow,
            })
          )
          .then((res) => {
            if (type) {
              this.isLoading = false;
            }
            if (res.code == "000") {
              this.list = this.list.concat(res.rows);
              this.loading = false;
              this.pageIndex += 1;
              if (res.rows.length == 0) {
                this.loading = false;
                this.finished = true;
              }
            } else {
              this.finished = true;
            }
          });
      }
    },

    toDetail(saleItemId, itemId) {
      this.$router.push({
        path: "/lotteryDetail",
        query: { saleItemId, itemId },
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "AnnounceDetail" || to.name === "OneHouseOnePrice") {
      this.$store.dispatch("saveView", ["AnnouncePre"]).then(() => {
        next();
      });
    } else {
      this.$store.dispatch("saveView", []).then(() => {
        next();
      });
    }
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  overflow: auto;
  background: #fff;
  border-radius: 10px;
  padding: 0 0.2rem;
  width: 80%;
  height: 80%;
  background-color: #fff;
  h3 {
    font-size: 0.4rem;
    text-align: center;
    padding: 0.5rem 0;
    font-weight: 900;
  }
  p {
    margin-bottom: 0.2rem;
    font-size: 0.3rem;
    text-align: left;
    span {
      font-weight: 900;
    }
  }
  .describe {
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn {
    padding: 0.5rem 0;
    display: flex;
    justify-content: space-around;
    p {
      border-radius: 5px;
      width: 2rem;
      padding: 0.1rem 0;
      text-align: center;
      font-size: 0.3rem;
    }
    .sure {
      border: 1px solid #64b5f6;
      color: #64b5f6;
    }
    .sure_two {
      border: 1px solid #64b5f6;
      background: #64b5f6;
      color: #fff;
    }
    .mayNot {
      border: 1px solid #ccc;
      color: #ccc;
    }
  }
}
// .overlay {
//   position: fixed;
//   top: 0;
//   left: 0;
//   bottom: 0;
//   top: 0;
//   right: 0;
//   background: rgba(0, 0, 0, 0.7);
//   z-index: 2000;
//   .block {
//     overflow: auto;
//     background: #fff;
//     position: absolute;
//     left: 50%;
//     transform: translateX(-50%);
//     top:10%;
//     border-radius: 10px;
//     padding: 0 0.2rem;
//     width: 80%;
//     height: 80%;
//     background-color: #fff;
//     h3 {
//       font-size: 0.4rem;
//       text-align: center;
//       padding: 0.5rem 0;
//       font-weight: 900;
//     }
//     p {
//       margin-bottom: 0.2rem;
//       font-size: 0.3rem;
//       text-align: left;
//       span {
//         font-weight: 900;
//       }
//     }
//     .describe {
//       padding: 10px 0;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//     .btn {
//       padding: 0.5rem 0;
//       display: flex;
//       justify-content: space-around;
//       p {
//         border-radius: 5px;
//         width: 2rem;
//         padding: 0.1rem 0;
//         text-align: center;
//         font-size: 0.3rem;
//       }
//       .sure{
//          border: 1px solid #64b5f6;
//          color: #64b5f6;
//       }
//       .sure_two {
//         border: 1px solid #64b5f6;
//         background: #64b5f6;
//         color: #fff;
//       }
//       .mayNot {
//         border: 1px solid #ccc;
//         color: #ccc;
//       }
//     }
//   }
// }

.fixed_pad {
  padding-top: 1.1rem;
}
.main_other {
  margin-top: 20px;
}
.fixed_pad_new {
  padding-top: 1.5rem;
}
.top_text {
  max-width: 50%;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.fixed_top {
  padding-top: 20px;
}
.header_address {
  font-size: 0.3rem;
  margin-right: 0.2rem;
  font-weight: 600;
  cursor: pointer;
  &.white {
    &:after {
      border-color: #fff transparent transparent transparent;
    }
  }
  &:after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0.08rem;
    margin-left: 0.1rem;
    margin-top: 0.08rem;
    border-color: #202020 transparent transparent transparent;
  }
}
.top_header {
  height: 0.7rem;
  line-height: 0.7rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  &.top_sm {
    padding: 0.1rem;
  }
  .search_con,
  .search_con_l {
    background-color: #f6f6f6;
    border: 1px solid #f0f0f0;
    border-radius: 0.7rem;
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.26rem;
    padding: 0 0.3rem;
    color: #303030;
    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }
  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }
  .search_con {
    width: 4rem;
  }
  .search_con_l {
    width: 5.72rem;
  }
  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.list_main {
  padding-bottom: 1rem;
  background-color: #fff;
}
.more_list {
  padding: 0 0.3rem 0;
  .more_con {
    padding-top: 0.46rem;
    height: 5.92rem;
    overflow: auto;
    box-sizing: border-box;
  }
  .btn_con {
    height: 1.2rem;
    box-sizing: border-box;
    border-top: 1px solid #f4f4f4;
    button {
      width: 3.3rem;
      line-height: 0.8rem;
      font-size: 0.28rem;
      border-radius: 0.02rem;
      &.reset {
        background-color: #eaf1ff;
        color: #2f72f5;
      }
      &.confirm {
        background-color: #2f72f5;
        color: #fff;
      }
    }
  }
  .row_con {
    margin-bottom: 0.54rem;
  }
  span {
    background-color: #f6f6f6;
    line-height: 0.66rem;
    width: 1.62rem;
    margin-right: 0.12rem;
    border-radius: 0.02rem;
    text-align: center;
    margin-bottom: 0.12rem;
    box-sizing: border-box;
    border: 1px solid #f6f6f6;
    &:nth-child(4n) {
      margin-right: 0;
    }
    &.active {
      color: #2f72f5;
      background-color: #eaf1ff;
      border: 1px solid #2f72f5;
    }
  }
}
.pad_top {
  padding-top: 0.78rem;
}
.list_con {
  margin: 0.05rem auto 0;
  width: 7.04rem;
  .inner {
    padding: 0.35rem 0;
    border-bottom: 1px solid #f4f4f4;
  }
  .banner {
    width: 2.44rem;
    height: 2rem;
  }
  .inner_l {
    position: relative;
    i {
      width: 0.6rem;
      height: 0.34rem;
      text-align: center;
      line-height: 0.34rem;
      color: #fff;
      background-color: #24d064;
      font-size: 0.24rem;
      position: absolute;
      display: block;
      top: 0;
    }
  }
  .new_r {
    .tel {
      width: 0.36rem;
      height: 0.36rem;
      img {
        width: 100%;
      }
    }
    img {
      width: 100%;
    }
    width: 6.25rem;
    margin-left: 0.3rem;
    .col_gray {
      font-size: 0.3rem;
      color: #000;
      i {
        margin: 0 0.2rem;
      }
    }
    .tit {
      h4 {
        font-size: 0.36rem;
        color: #101010;
        font-weight: 800;
        max-width: 4.8rem;
      }
      i {
        //width: 0.6rem;
        padding: 0 0.04rem;
        line-height: 0.34rem;
        color: #2f72f5;
        font-size: 0.24rem;
        text-align: center;
        border: 1px solid currentColor;
        box-sizing: border-box;
        border-radius: 0.02rem;
      }
      span {
        text-align: center;
        line-height: 0.34rem;
        padding: 0.03rem 0.05rem;
        color: #ffffff;
        font-size: 0.24rem;
        border-radius: 0.02rem;
      }
      .span_one {
        background-color: #81c784;
      }
      .span_two {
        background-color: #f44336;
      }
      .span_three {
        background-color: #f57f17;
      }
    }
  }
}
.pre_list {
  .col_gray {
    &:not(:last-child) {
      margin: 0.1rem 0;
    }
  }
}
.confirmBtn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0.2rem 1rem;
  height: 1.2rem;
  p {
    border-radius: 10px;
    width: 100%;
    line-height: 0.8rem;
    font-size: 0.3rem;
    color: #fff;
    height: 100%;
    background: #64b5f6;
    text-align: center;
  }
}
</style>